<template>
  <div class="country-selector" ref="dropdown">
    <button
      type="button"
      @click="toggleDropdown"
      class="country-button"
      :disabled="disabled"
    >
      <span class="country-flag">{{ selectedCountry && selectedCountry.flag }}</span>
      <span class="country-code">{{ selectedCountry && selectedCountry.dialCode }}</span>
    </button>

    <div v-if="isOpen" class="country-dropdown">
      <div class="search-container">
        <input
          ref="searchInput"
          v-model="searchTerm"
          type="text"
          placeholder="Search countries..."
          class="search-input"
        />
      </div>
      <div class="countries-list">
        <button
          v-for="country in filteredCountries"
          :key="country.code"
          type="button"
          @click="selectCountry(country)"
          class="country-option"
          :class="{ selected: selectedCountry && selectedCountry.code === country.code }"
        >
          <span class="country-flag">{{ country.flag }}</span>
          <span class="country-code">{{ country.dialCode }}</span>
          <span class="country-name">{{ country.name }}</span>
        </button>
        <div v-if="filteredCountries.length === 0" class="no-results">
          No countries found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const COUNTRIES = [
  {
    code: 'US', name: 'United States', dialCode: '+1', flag: '🇺🇸',
  },
  {
    code: 'CA', name: 'Canada', dialCode: '+1', flag: '🇨🇦',
  },
  {
    code: 'GB', name: 'United Kingdom', dialCode: '+44', flag: '🇬🇧',
  },
  {
    code: 'AU', name: 'Australia', dialCode: '+61', flag: '🇦🇺',
  },
  {
    code: 'DE', name: 'Germany', dialCode: '+49', flag: '🇩🇪',
  },
  {
    code: 'FR', name: 'France', dialCode: '+33', flag: '🇫🇷',
  },
  {
    code: 'IT', name: 'Italy', dialCode: '+39', flag: '🇮🇹',
  },
  {
    code: 'ES', name: 'Spain', dialCode: '+34', flag: '🇪🇸',
  },
  {
    code: 'NL', name: 'Netherlands', dialCode: '+31', flag: '🇳🇱',
  },
  {
    code: 'BE', name: 'Belgium', dialCode: '+32', flag: '🇧🇪',
  },
  {
    code: 'CH', name: 'Switzerland', dialCode: '+41', flag: '🇨🇭',
  },
  {
    code: 'AT', name: 'Austria', dialCode: '+43', flag: '🇦🇹',
  },
  {
    code: 'SE', name: 'Sweden', dialCode: '+46', flag: '🇸🇪',
  },
  {
    code: 'NO', name: 'Norway', dialCode: '+47', flag: '🇳🇴',
  },
  {
    code: 'DK', name: 'Denmark', dialCode: '+45', flag: '🇩🇰',
  },
  {
    code: 'FI', name: 'Finland', dialCode: '+358', flag: '🇫🇮',
  },
  {
    code: 'PL', name: 'Poland', dialCode: '+48', flag: '🇵🇱',
  },
  {
    code: 'CZ', name: 'Czech Republic', dialCode: '+420', flag: '🇨🇿',
  },
  {
    code: 'HU', name: 'Hungary', dialCode: '+36', flag: '🇭🇺',
  },
  {
    code: 'PT', name: 'Portugal', dialCode: '+351', flag: '🇵🇹',
  },
  {
    code: 'GR', name: 'Greece', dialCode: '+30', flag: '🇬🇷',
  },
  {
    code: 'IE', name: 'Ireland', dialCode: '+353', flag: '🇮🇪',
  },
  {
    code: 'JP', name: 'Japan', dialCode: '+81', flag: '🇯🇵',
  },
  {
    code: 'KR', name: 'South Korea', dialCode: '+82', flag: '🇰🇷',
  },
  {
    code: 'CN', name: 'China', dialCode: '+86', flag: '🇨🇳',
  },
  {
    code: 'IN', name: 'India', dialCode: '+91', flag: '🇮🇳',
  },
  {
    code: 'SG', name: 'Singapore', dialCode: '+65', flag: '🇸🇬',
  },
  {
    code: 'HK', name: 'Hong Kong', dialCode: '+852', flag: '🇭🇰',
  },
  {
    code: 'MY', name: 'Malaysia', dialCode: '+60', flag: '🇲🇾',
  },
  {
    code: 'TH', name: 'Thailand', dialCode: '+66', flag: '🇹🇭',
  },
  {
    code: 'PH', name: 'Philippines', dialCode: '+63', flag: '🇵🇭',
  },
  {
    code: 'ID', name: 'Indonesia', dialCode: '+62', flag: '🇮🇩',
  },
  {
    code: 'VN', name: 'Vietnam', dialCode: '+84', flag: '🇻🇳',
  },
  {
    code: 'BR', name: 'Brazil', dialCode: '+55', flag: '🇧🇷',
  },
  {
    code: 'MX', name: 'Mexico', dialCode: '+52', flag: '🇲🇽',
  },
  {
    code: 'AR', name: 'Argentina', dialCode: '+54', flag: '🇦🇷',
  },
  {
    code: 'CL', name: 'Chile', dialCode: '+56', flag: '🇨🇱',
  },
  {
    code: 'CO', name: 'Colombia', dialCode: '+57', flag: '🇨🇴',
  },
  {
    code: 'PE', name: 'Peru', dialCode: '+51', flag: '🇵🇪',
  },
  {
    code: 'ZA', name: 'South Africa', dialCode: '+27', flag: '🇿🇦',
  },
  {
    code: 'EG', name: 'Egypt', dialCode: '+20', flag: '🇪🇬',
  },
  {
    code: 'NG', name: 'Nigeria', dialCode: '+234', flag: '🇳🇬',
  },
  {
    code: 'KE', name: 'Kenya', dialCode: '+254', flag: '🇰🇪',
  },
  {
    code: 'IL', name: 'Israel', dialCode: '+972', flag: '🇮🇱',
  },
  {
    code: 'AE', name: 'United Arab Emirates', dialCode: '+971', flag: '🇦🇪',
  },
  {
    code: 'SA', name: 'Saudi Arabia', dialCode: '+966', flag: '🇸🇦',
  },
  {
    code: 'TR', name: 'Turkey', dialCode: '+90', flag: '🇹🇷',
  },
  {
    code: 'RU', name: 'Russia', dialCode: '+7', flag: '🇷🇺',
  },
  {
    code: 'UA', name: 'Ukraine', dialCode: '+380', flag: '🇺🇦',
  },
  {
    code: 'NZ', name: 'New Zealand', dialCode: '+64', flag: '🇳🇿',
  },
].sort((a, b) => a.name.localeCompare(b.name));

export default {
  name: 'CountrySelector',
  props: {
    value: {
      type: Object,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
      searchTerm: '',
      selectedCountry: this.value,
    };
  },
  computed: {
    filteredCountries() {
      if (!this.searchTerm) return COUNTRIES;

      const term = this.searchTerm.toLowerCase();
      return COUNTRIES.filter(country => country.name.toLowerCase().includes(term) ||
        country.dialCode.includes(term) ||
        country.code.toLowerCase().includes(term));
    },
  },
  watch: {
    value(newValue) {
      this.selectedCountry = newValue;
    },
  },
  mounted() {
    // Auto-detect country if none selected
    if (!this.selectedCountry) {
      const detectedCountry = this.detectCountry();
      const country = COUNTRIES.find(c => c.code === detectedCountry) || COUNTRIES.find(c => c.code === 'US');
      this.selectCountry(country);
    }

    // Close dropdown when clicking outside
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    detectCountry() {
      try {
        // Try to detect from timezone
        if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
          const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const timezoneToCountry = {
            'America/New_York': 'US',
            'America/Chicago': 'US',
            'America/Denver': 'US',
            'America/Los_Angeles': 'US',
            'America/Toronto': 'CA',
            'America/Vancouver': 'CA',
            'Europe/London': 'GB',
            'Europe/Berlin': 'DE',
            'Europe/Paris': 'FR',
            'Europe/Rome': 'IT',
            'Europe/Madrid': 'ES',
            'Europe/Amsterdam': 'NL',
            'Asia/Tokyo': 'JP',
            'Asia/Seoul': 'KR',
            'Asia/Shanghai': 'CN',
            'Asia/Kolkata': 'IN',
            'Australia/Sydney': 'AU',
          };

          if (timezoneToCountry[timezone]) {
            return timezoneToCountry[timezone];
          }
        }
        // Fallback to locale detection
        if (typeof navigator !== 'undefined' && navigator.language) {
          const parts = navigator.language.split('-');
          if (parts.length > 1) {
            return parts[1].toUpperCase();
          }
        }
      } catch (error) {
        // Country detection failed, will use default fallback
      }
      return 'US'; // Default fallback
    },

    toggleDropdown() {
      if (this.disabled) return;
      this.isOpen = !this.isOpen;

      if (this.isOpen) {
        this.$nextTick(() => {
          if (this.$refs.searchInput) {
            this.$refs.searchInput.focus();
          }
        });
      } else {
        this.searchTerm = '';
      }
    },

    selectCountry(country) {
      this.selectedCountry = country;
      this.isOpen = false;
      this.searchTerm = '';
      this.$emit('input', country);
      this.$emit('change', country);
    },

    handleClickOutside(event) {
      if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
        this.searchTerm = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.country-selector {
  position: relative;
  display: inline-block;
}

.country-button {
  display: flex;
  align-items: center;
  gap: $space-1;
  padding: $space-2 $space-3;
  height: $input-height-md;
  background: var(--bg-primary);
  border: 2px solid var(--border-primary);
  border-radius: $radius-lg;
  font-size: $font-size-base;
  cursor: pointer;
  transition: all 0.3s ease;
  width: 100%;
  min-width: rem(85);

  &:hover:not(:disabled) {
    border-color: var(--border-secondary);
  }

  &:focus {
    outline: none;
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 3px rgba(143, 36, 208, 0.1);
    transform: translateY(-1px);
  }

  &:disabled {
    background-color: var(--bg-secondary);
    cursor: not-allowed;
    opacity: 0.7;
  }
}

.country-flag {
  font-size: $font-size-xl;
}

.country-code {
  font-weight: 600;
  color: var(--text-primary);
  font-size: $font-size-sm;
  white-space: nowrap;
}

.country-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: $space-1;
  background: var(--bg-primary);
  border: 1px solid var(--border-primary);
  border-radius: $radius-md;
  box-shadow: $shadow-lg;
  z-index: $z-dropdown;
  min-width: rem(280);
  max-height: rem(300);
  overflow: hidden;
}

.search-container {
  padding: $space-3;
  border-bottom: 1px solid var(--border-primary);
}

.search-input {
  width: 100%;
  padding: $space-2;
  border: 1px solid var(--border-primary);
  border-radius: $radius-md;
  font-size: $font-size-base;
  background: var(--bg-primary);
  color: var(--text-primary);

  &:focus {
    outline: none;
    border-color: var(--brand-primary);
    box-shadow: 0 0 0 2px rgba(143, 36, 208, 0.1);
  }

  &::placeholder {
    color: var(--text-muted);
  }
}

.countries-list {
  max-height: rem(200);
  overflow-y: auto;
}

.country-option {
  width: 100%;
  display: flex;
  align-items: center;
  gap: $space-3;
  padding: $space-3;
  background: none;
  border: none;
  text-align: left;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--bg-secondary);
  }

  &.selected {
    background-color: var(--highlight-blue-bg);
    color: var(--brand-primary);
    font-weight: 600;
  }

  .country-flag {
    font-size: $font-size-xl;
  }

  .country-code {
    font-weight: 600;
    min-width: rem(50);
    color: var(--text-primary);
  }

  .country-name {
    font-size: $font-size-base;
    color: var(--text-primary);
  }
}

.no-results {
  padding: $space-4;
  text-align: center;
  color: var(--text-muted);
  font-size: $font-size-base;
}
</style>
